export default __webpack_public_path__ + "static/media/sem-foto.e851bfb2.jpg";